import { AfterBanksParameters } from '#/pages/accounting/payouts/components/reconcilePayoutsModal/ModalContext';
import { doGet } from '#lib/network/helpers';

export const afterbanks = {
  getParameters: () =>
    doGet<AfterBanksParameters>('/dashboard/afterbanks/parameters')
};
